import { Locale, type LocalizedString } from "../Locale.js";

export const vertiNodeUrlMap: LocalizedString = {
	[Locale.cs]: "https://cz.vertinode.ai",
	[Locale.en]: "https://www.vertinode.ai",
};
